/* eslint-disable @typescript-eslint/no-var-requires */
import { library } from '@fortawesome/fontawesome-svg-core';

const IconService = {
  init: () =>
    library.add(
      require('@fortawesome/pro-solid-svg-icons/faThLarge').definition,
      require('@fortawesome/pro-solid-svg-icons/faRedo').definition,
      require('@fortawesome/pro-solid-svg-icons/faEyeDropper').definition,
      require('@fortawesome/pro-solid-svg-icons/faChevronUp').definition,
      require('@fortawesome/pro-solid-svg-icons/faChevronDown').definition,
      require('@fortawesome/pro-solid-svg-icons/faChevronRight').definition,
      require('@fortawesome/pro-solid-svg-icons/faChevronLeft').definition,
      require('@fortawesome/pro-solid-svg-icons/faCheckCircle').definition,
      require('@fortawesome/pro-solid-svg-icons/faSunBright').definition,
      require('@fortawesome/pro-solid-svg-icons/faMoon').definition,
      require('@fortawesome/pro-duotone-svg-icons/faCheckCircle').definition,
      require('@fortawesome/pro-regular-svg-icons/faTags').definition,
      require('@fortawesome/pro-duotone-svg-icons/faCheck').definition,
      require('@fortawesome/pro-regular-svg-icons/faClock').definition,
      require('@fortawesome/pro-regular-svg-icons/faEllipsisV').definition,
      require('@fortawesome/pro-regular-svg-icons/faExclamationTriangle').definition,
      require('@fortawesome/pro-duotone-svg-icons/faTimes').definition,
      require('@fortawesome/pro-regular-svg-icons/faSunBright').definition,
      require('@fortawesome/pro-regular-svg-icons/faMoon').definition,
      require('@fortawesome/pro-regular-svg-icons/faGift').definition,
      require('@fortawesome/pro-regular-svg-icons/faTimes').definition,
      require('@fortawesome/pro-regular-svg-icons/faEye').definition,
      require('@fortawesome/pro-regular-svg-icons/faEyeSlash').definition,
      require('@fortawesome/pro-regular-svg-icons/faInfoCircle').definition,
      require('@fortawesome/pro-regular-svg-icons/faPlus').definition,
      require('@fortawesome/pro-regular-svg-icons/faKey').definition,
      require('@fortawesome/pro-regular-svg-icons/faMobile').definition,
      require('@fortawesome/pro-regular-svg-icons/faCreditCardFront').definition,
      require('@fortawesome/pro-regular-svg-icons/faCreditCard').definition,
      require('@fortawesome/pro-regular-svg-icons/faCalendar').definition,
      require('@fortawesome/pro-regular-svg-icons/faUserCircle').definition,
      require('@fortawesome/pro-regular-svg-icons/faAngleDown').definition,
      require('@fortawesome/pro-regular-svg-icons/faAngleUp').definition,
      require('@fortawesome/pro-regular-svg-icons/faAngleRight').definition,
      require('@fortawesome/pro-regular-svg-icons/faQuestionCircle').definition,
      require('@fortawesome/pro-regular-svg-icons/faCommentAltDots').definition,
      require('@fortawesome/pro-regular-svg-icons/faLightbulbExclamation').definition,
      require('@fortawesome/pro-regular-svg-icons/faExclamationCircle').definition,
      require('@fortawesome/pro-regular-svg-icons/faCamera').definition,
      require('@fortawesome/pro-regular-svg-icons/faWallet').definition,
      require('@fortawesome/pro-regular-svg-icons/faCheck').definition,
      require('@fortawesome/pro-regular-svg-icons/faUser').definition,
      require('@fortawesome/pro-regular-svg-icons/faThLarge').definition,
      require('@fortawesome/pro-regular-svg-icons/faSms').definition,
      require('@fortawesome/pro-regular-svg-icons/faPhoneAlt').definition,
      require('@fortawesome/pro-regular-svg-icons/faImage').definition,
      require('@fortawesome/pro-regular-svg-icons/faBolt').definition,
      require('@fortawesome/pro-regular-svg-icons/faDesktop').definition,
      require('@fortawesome/pro-regular-svg-icons/faArrowLeft').definition,
      require('@fortawesome/pro-regular-svg-icons/faArrowRight').definition,
      require('@fortawesome/pro-regular-svg-icons/faArrowDownLeft').definition,
      require('@fortawesome/pro-regular-svg-icons/faCopy').definition,
      require('@fortawesome/pro-light-svg-icons/faCheckCircle').definition,
      require('@fortawesome/pro-regular-svg-icons/faCoins').definition,
      require('@fortawesome/pro-regular-svg-icons/faSms').definition,
      require('@fortawesome/pro-regular-svg-icons/faComment').definition,
      require('@fortawesome/pro-regular-svg-icons/faSync').definition,
      require('@fortawesome/pro-regular-svg-icons/faCookie').definition,
      require('@fortawesome/pro-regular-svg-icons/faXmark').definition,
    ),
};

export default IconService;
